export default __webpack_public_path__ + "static/media/scroll-top-icon.fc4d5810.svg";